import axios from "../utils/ajaxRequest";

export const publicDetail = (params) => axios.request({url: '/articles/getInfo', method: 'POST', data: params});
export const publicNewsDetail = (params) => axios.request({url: '/articles/getDetail', method: 'POST', data: params});

export default {};